import React, { useEffect } from 'react';
import './HomeAbout.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons';
import { faBars, faTimes,  faPencilRuler, faTachometerAlt, faRocket } from '@fortawesome/free-solid-svg-icons';
import mrenanImage from '../../../images/person/mrenan.JPG';
import HomeSkillProgressBar from '../HomeSkillProgressBar/HomeSkillProgressBar';
import { faFacebook, faGithub, faHackerrank, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import Aos from 'aos';
import "aos/dist/aos.css";

const HomeAbout = () => {
    const cardAnimateType ={
        0: "flip-left",
        1: "flip-down",
        2: "flip-left",
        3: "flip-right",
    }

    return (
        <div className="home-about-main-container">
            <h2 className="home-about-title">About</h2>
            {/* about section */}
            <div>
                <div className="home-about-card-container">
                    {/* fast */}
                    <div className="home-about-card-details">
                        <div className="home-about-card-font-container">
                            <FontAwesomeIcon className="home-about-font-icon" icon={faTachometerAlt}/>
                        </div>
                        <h3>Fast</h3>
                        <p>Fast load times and lag free interaction, My highest priority.</p>
                    </div>
                    {/* responsive */}
                    <div className="home-about-card-details">
                        <div className="home-about-card-font-container">
                            <FontAwesomeIcon className="home-about-font-icon" icon={faPencilRuler}/>
                        </div>
                        <h3>Responsive</h3>
                        <p>My layouts will work on any device</p>
                    </div>
                    {/* Dynamic */}
                    <div className="home-about-card-details">
                        <div className="home-about-card-font-container">
                            <FontAwesomeIcon className="home-about-font-icon" icon={faRocket}/>
                        </div>
                        <h3>Dynamic</h3>
                        <p>Websites don't have to be static. I love making pages come to life.</p>
                    </div>
                    {/* Intutive */}
                    <div className="home-about-card-details">
                        <div className="home-about-card-font-container">
                            <FontAwesomeIcon className="home-about-font-icon" icon={faLightbulb}/>
                        </div>
                        <h3>Intuitive</h3>
                        <p>Strong preference for easy to use, intuitive UX/UI</p>
                    </div>
                </div>
            </div>
            <div className="home-about-dev-parent-container">
                <div id="home-about" className="home-about-dev-info-details-container">
                    <div className="home-about-dev-info-image-container">
                        <img src={mrenanImage} alt="" />
                    </div>
                    <p className="home-about-dev-info-description">I'm a full stack web developer.<br/> I have a expertise in Html, JavaScript, Css, React. I also can develop a site using Bootstrap, Tailwind, Material Ui, MongoDb, Node.js, firebase and up to date technologies. I have passion for UI effects, animation and creating intuitive also.I also prefer to make the website responsive, dynamic and optimized for better user experience.</p>
                    <div className="home-about-profile-link-container">
                        <a href="https://github.com/MRIEnan" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faGithub}/></a>
                        <a href="https://www.linkedin.com/in/mainur-rahman-enan/" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faLinkedin}/></a>
                        <a href="https://www.hackerrank.com/enan_mainur" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faHackerrank}/></a>
                        <a href="https://www.facebook.com/MRENAN.127/" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faFacebook}/></a>
                    </div>
                </div>
                <div className="home-about-dev-skill">
                    <div>
                    <HomeSkillProgressBar animationType={0} bgcolor="#525E65" tech='Css' progress='80'  height={30} />
                    <HomeSkillProgressBar animationType={2} bgcolor="#525E65" tech='html' progress='85'  height={30} />
                    <HomeSkillProgressBar animationType={3} bgcolor="#525E65" tech='Javascript' progress='70'  height={30} />
                    <HomeSkillProgressBar animationType={2} bgcolor="#525E65" tech='React' progress='70'  height={30} />
                    <HomeSkillProgressBar animationType={3} bgcolor="#525E65" tech='SASS' progress='70'  height={30} />
                    <HomeSkillProgressBar animationType={2} bgcolor="#525E65" tech='Bootstrap' progress='80'  height={30} />
                    <HomeSkillProgressBar animationType={3} bgcolor="#525E65" tech='Material UI' progress='80'  height={30} />
                    <HomeSkillProgressBar animationType={2} bgcolor="#525E65" tech='Tailwind' progress='70'  height={30} />
                    <HomeSkillProgressBar animationType={3} bgcolor="#525E65" tech='Firebase' progress='80'  height={30} />
                    <HomeSkillProgressBar animationType={0} bgcolor="#525E65" tech='MongoDb' progress='60'  height={30} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeAbout;